module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vacations"
  }, [_c('div', [_vm._v("Dein Urlaubsanspruch: " + _vm._s(_vm.vacationData.vacation_days))]), _c('div', [_vm._v("Bereits in Anspruch genommen: " + _vm._s(_vm.vacationData.used_vacation_days_till_today))]), _c('div', [_vm._v("Geplante Urlaubstage: " + _vm._s(_vm.vacationData.planned_vacation_days))]), _c('div', [_vm._v("Resturlaub (heute): " + _vm._s(_vm.vacationData.open_vacation_days))]), _vm._m(0), _c('form', [_c('label', [_vm._v("Von:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_vacation.start),
      expression: "new_vacation.start"
    }],
    attrs: {
      "type": "date",
      "name": "start",
      "required": "required"
    },
    domProps: {
      "value": (_vm.new_vacation.start)
    },
    on: {
      "change": _vm.setEnd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_vacation, "start", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Bis:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_vacation.end),
      expression: "new_vacation.end"
    }],
    attrs: {
      "type": "date",
      "name": "end",
      "required": "required"
    },
    domProps: {
      "value": (_vm.new_vacation.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_vacation, "end", $event.target.value)
      }
    }
  }), _c('br'), (_vm.error) ? _c('div', [_c('br'), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _c('br'), _c('button', {
    on: {
      "click": _vm.submitVacation
    }
  }, [_vm._v("Urlaub Beantragen")])]), _c('div', [_c('strong', [_vm._v("Eingereichte Urlaube")]), _vm._l((_vm.vacations), function(vacation) {
    return _c('vacation', {
      key: vacation.id,
      attrs: {
        "vacation": vacation,
        "user": _vm.user
      },
      on: {
        "reload-vacations": function($event) {
          _vm.$emit('reload-vacations');
          _vm.loadVacationData()
        }
      }
    })
  }), (_vm.vacations.length == 0) ? _c('div', [_vm._v("keine")]) : _vm._e()], 2), _c('div', [_c('strong', {
    staticClass: "otherVacations",
    class: {
      'visible': _vm.showOtherVacations
    },
    on: {
      "click": function($event) {
        _vm.showOtherVacations = !_vm.showOtherVacations
      }
    }
  }, [_vm._v("Urlaub in meinen Gewerken")])]), (_vm.showOtherVacations) ? _c('div', [_vm._l((_vm.otherVacations), function(vacation) {
    return _c('dl', {
      key: vacation.id,
      staticClass: "vacation"
    }, [_c('dt', {
      class: vacation.status
    }, [_vm._v("Von " + _vm._s(_vm._f("moment")(vacation.start, 'DD.MM.YYYY')))]), _c('dd', [_vm._v("bis " + _vm._s(_vm._f("moment")(vacation.end, 'DD.MM.YYYY')) + " - " + _vm._s(vacation.name))])])
  }), (_vm.otherVacations.length == 0) ? _c('span', [_vm._v("keine")]) : _vm._e()], 2) : _vm._e(), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Neuen Urlaub einreichen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Legende")]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "new"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Unbearbeitet")])]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "accepted"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Genehmigt")])]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "denied"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Abgelehnt")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ed8a10"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vacations.vue
// module id = 1082
// module chunks = 1